// 引用 Mock
const Mock = require('mockjs')
 let listObj = {                //类型：Object  必有字段  备注：无
  "distUserName":"mock",                //类型：String  必有字段  备注：分销用户名称
  "distUserId":"mock",                //类型：String  必有字段  备注：分销用户id
  "distUserMobile":"mock",                //类型：String  必有字段  备注：分销用户号码
  "buyerName":"mock",                //类型：String  必有字段  备注：下单用户名称
  "buyerId":"mock",                //类型：String  必有字段  备注：下单用户id
  "buyerMobile":"mock",                //类型：String  必有字段  备注：下单用户号码
  "orderNo":"mock",                //类型：String  必有字段  备注：订单编号
  "actualPayment":"mock",                //类型：String  必有字段  备注：实付金额（分）
  "commission":1,                //类型：Number  必有字段  备注：分佣金额（分）
  "status":1,                //类型：Number  必有字段  备注：结算状态 0-未结算 1-已结算 2-已失效
  "gmtCreate":"mock",                //类型：String  必有字段  备注：订单创建时间
  "distUserGroupName":"mock",                //类型：String  必有字段  备注：分组名称
  "refundTime":"mock"                //类型：String  必有字段  备注：订单退款时间
}
let listArry = []
for(let i=1;i<93;i++){
  listArry.push(listObj)
}
export const userData = Mock.mock("/mock/test", "post", {
  data: listArry,
  success: true,
  message: 'ok',
});